<div class="nova__dialog__toolbar">
    <div class="nova__dialog__toolbar__title">
        <span>Offer Details to Offer Margin Comparison - {{data.candidateName}}</span>
    </div>
    <button mat-icon-button aria-label="close dialog" [mat-dialog-close]="false" tabindex="-1">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div mat-dialog-content class="nova__dialog__content" >

    <table mat-table [dataSource]="differences" aria-label="differences">
        <ng-container matColumnDef="propertyName">
            <th class="prop-name header prop-name-header" mat-header-cell *matHeaderCellDef></th>
            <td class="prop-name" mat-cell *matCellDef="let row">{{row.propertyName}}</td>
        </ng-container>

        <ng-container matColumnDef="valueInOffer">
            <th class="pr-3 header" mat-header-cell *matHeaderCellDef>Offer Details</th>
            <td class="pr-3" mat-cell *matCellDef="let row">{{row.valueInOffer}}</td>
        </ng-container>

        <ng-container matColumnDef="valueInMargin">
            <th class="margin-tint header" mat-header-cell *matHeaderCellDef>Offer Margin - {{data.marginId}}</th>
            <td class="margin-tint" mat-cell *matCellDef="let row">{{row.valueInMargin}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <div class="flex-row pt-3">
        <div>
            <button mat-raised-button
                    [mat-dialog-close]="false"
                    class="back-btn">
                CLOSE
            </button>
        </div>
    </div>
</div>
